export const ATTENDANCE_TIMEOUT: number = 150; // seconds
